import { request } from "axios/request";

import {
  FETCH_BASKET_PENDING,
  FETCH_BASKET_REJECTED,
  FETCH_BASKET_FULFILLED,
  FETCH_VOUCHERCODE_REJECTED,
  FETCH_CUSTOMER_FULFILLED,
  REMOVE_BASKET_ITEMS,
  COMPLETE_CALL_CENTER_FULFILLED,
} from "constants/basket";

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_BASKET_PENDING,
});

const rejected = (error) => ({
  type: FETCH_BASKET_REJECTED,
  error: error,
});

const fulfilled = (response) => ({
  type: FETCH_BASKET_FULFILLED,
  response: response,
});

const completeCallCenter = (response) => ({
  type: COMPLETE_CALL_CENTER_FULFILLED,
  response: response,
});

const customerFulfilled = (response) => ({
  type: FETCH_CUSTOMER_FULFILLED,
  response: response,
});

const voucherCodeRejected = (error) => ({
  type: FETCH_VOUCHERCODE_REJECTED,
  error: error,
});

export const fetchBasket = () => (dispatch) => {
  dispatch(pending());

  request({ url: $U.BASKET, method: "get" })
    .then((response) => {
      dispatch(fulfilled(response.data));
      localStorage.setItem("localBaskedItem", JSON.stringify(response.data));
      dispatch(fetchCurrentCustomer());
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

const fetchCurrentCustomer = () => (dispatch) => {
  request({ url: $U.CUSTOMER_CURRENT, method: "get" })
    .then((response) => {
      dispatch(customerFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

// DEĞİŞİM KAMPANYASI SEPETİNİ TEMİZLE
export const deleteChangeCampaignItemOnBasket =
  (quantity, pk, attributes) => (dispatch) => {
    dispatch(pending());

    request({
      url: $U.BASKET,
      method: "PUT",
      data: {
        product: pk,
        quantity: quantity,
        attributes: attributes,
      },
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

// DEĞİŞİM KAMPANYASI MÜŞTERİ TELEFONUNU SEPETTEN SİL
export const deleteCustomerPhoneOnBasket =
  (attributes, id, is_all) => (dispatch) => {
    dispatch(pending());

    request({
      url: $U.BASKET_ITEM,
      method: "PATCH",
      data: {
        attributes: attributes,
        id: id,
        is_all: is_all,
      },
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const completeCallCenterProcess = (id, number) => (dispatch) => {
  const url = $U.ONCALL_ORDER_COMPLETE.replace("{0}", id);
  const data = { order: number };

  dispatch(pending());

  request({
    url,
    method: "POST",
    data,
  })
    .then((response) => {
      dispatch(completeCallCenter(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setQuantity = (quantity, product, attributes) => (dispatch) => {
  request({
    url: $U.BASKET,
    method: "PUT",
    data: {
      product: product,
      quantity: quantity,
      attributes: attributes,
    },
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
      localStorage.setItem("localBaskedItem", JSON.stringify(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const setVoucherCode = (voucher_code, remove) => (dispatch) => {
  request({
    url: $U.BASKET,
    method: "PATCH",
    data: remove ? "remove_voucher_code=true" : `voucher_code=${voucher_code}`,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(voucherCodeRejected(error));
    });
};

export const removeBasketItems = () => (dispatch) => {
  dispatch({ type: REMOVE_BASKET_ITEMS });
};

export const moveBasket = () => (dispatch, getState) => {
  let counter = 0;
  const basketItems = getState().basket.basketItems;

  const add = (index, items) => {
    const item = items[index];
    counter++;

    if (!!item) {
      request({
        url: $U.BASKET,
        method: "POST",
        data: {
          product: item.product.pk,
          quantity: item.quantity,
          attributes: item.attributes,
        },
      })
        .then(() => {
          add(counter, items);
        })
        .catch(() => {
          add(counter, items);
        });
    } else {
      // dispatch(removeBasketItems())
      dispatch(fetchBasket());
    }
  };

  add(basketItems.length, basketItems);
};



// WEBPACK FOOTER //
// ./src/actions/basket.js